import { render, staticRenderFns } from "./WeekQualityControlModal.vue?vue&type=template&id=632d7c25&"
import script from "./WeekQualityControlModal.vue?vue&type=script&lang=js&"
export * from "./WeekQualityControlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports